/**
 * Reordering inside one campaign must not move anybody else: the dragged
 * subset is written back into the SAME positions it held in the plan-wide
 * execution order, so containers of other campaigns keep their place (and
 * "after previous" chains keep their neighbours).
 * For Media Devoted | Created By Ciro Autiero
 */
export function mergeSubsetOrder<T extends { id: string }>(full: T[], subsetInNewOrder: T[]): T[] {
  const inSubset = new Set(subsetInNewOrder.map((c) => c.id));
  let next = 0;
  return full.map((c) => (inSubset.has(c.id) ? subsetInNewOrder[next++] : c));
}
